<div class="container-customer">
	<app-users-feedback [componentStyle]="isTitleGreen"></app-users-feedback>
</div>